import * as React from "react";

import InfoTwoTone from "@material-ui/icons/InfoTwoTone";
import { WithTranslation, withTranslation } from "react-i18next";
import Topic from "~/components/CustomerSupport/Topic";
import { StyledCard as Card } from "~/layouts/StyledCard";

interface IProps {
  title: string;
}

class QuestionsHeader extends React.Component<WithTranslation & IProps> {
  public render() {
    const { t, title } = this.props;

    return (
      <Card>
        <Topic
          title={title}
          icon={InfoTwoTone}
          description_html={t("header.description_html", { title })}
        />
      </Card>
    );
  }
}

export default withTranslation("faq")(QuestionsHeader);



// WEBPACK FOOTER //
// ./src/components/FAQ/QuestionsHeader.tsx